module.exports = __webpack_public_path__ + "static/media/decare.303539a7.png";